<template>
  <div class="contain">
    <img class="gz_title" :src="$img( 'gz.png' )" />

    <div class="wrap">

      <div v-if="list.length" class="swiper-container gz-swiper-container">
        <div class="swiper-wrapper">
          <router-link :to="'/cont/' + item.id + '/gz'" v-for="(item, index) in list" :key="index" class="swiper-slide">
            <img :src="item.cover" />
            <p>{{item.title}}</p>
          </router-link>
        </div>

      </div>

      <!-- Add Pagination -->
      <div class="swiper-pagination gz-swiper-pagination"></div>

      <div class="p3-prev"></div>
      <div class="p3-next"></div>

    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      list: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$api('GET', '/article?type=champion&number=80').then(res => {
        console.log(res)
        this.list = res.data.data
        setTimeout(() => {
          new Swiper('.gz-swiper-container', {
            slidesPerView: 3,
            slidesPerColumn: 2,
            slidesPerGroup: 3,
            spaceBetween: 30,
            pagination: '.gz-swiper-pagination',
            paginationClickable: true,
            prevButton: '.p3-prev',
            nextButton: '.p3-next',
            paginationBulletRender: function (swiper, index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>'
            }
          })
        }, 180)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
  position: relative;
  height: 100%;
  background: url('../assets/images/cs_bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  /deep/ .swiper-pagination-bullet {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #fff;
    margin: 0 4px;
  }
  /deep/ .swiper-pagination-bullet {
    background: #525252;
    opacity: 1;
  }
  /deep/ .swiper-pagination-bullet-active {
    background: #d99a3e;
  }
  /deep/ .swiper-pagination {
    text-align: center;
    padding: 22px 0;
    display: fixed;
    width: 100%;
  }

  .wrap {
    position: relative;
  }

  .p3-prev {
    width: 48px;
    height: 88px;
    position: absolute;
    top: 220px;
    left: -80px;
    background-size: cover;
    background: url('../assets/images/prev.png');
    z-index: 2;
    cursor: pointer;
  }

  .p3-next {
    width: 48px;
    height: 88px;
    position: absolute;
    top: 220px;
    right: -80px;
    background-size: cover;
    background: url('../assets/images/next.png');
    z-index: 2;
    cursor: pointer;
  }
}

.gz_title {
  position: absolute;
  top: 20px;
  left: calc( 50% - 155px );
}

.wrap {
  width: 950px;
  margin: 0 auto;
  position: relative;
  top: 208px;
}

.gz-swiper-container {
  .swiper-slide {
    cursor: pointer;
    height: 235px;
    background: url('../assets/images/ds.png');
    padding: 14px;
    img {
      display: block;
      width: 100%;
    }
    p {
      width: 100%;
      display: block;
      font-size: 14px;
      color: #fff;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: nowrap;
    }
  }
}
</style>